/* =============================================================================
   Studio 47° Pilates — shop / cart-drawer controller
   Loaded globally from layout/theme.liquid. Responsibilities:
     1. Intercept the standard PDP <form action="/cart/add">: ajax-add to cart
        and slide the drawer open instead of redirecting to /cart.
     2. Provide drawer open/close + qty/remove/subtotal updates.
     3. Update the header cart-count badge from /cart.js after every change.
     4. Cooperate with s47-cart.js (pricing page) — both share the same
        Ajax Cart API; this file does not touch pack-card buttons.
   ============================================================================= */
(function () {
  'use strict';

  var moneyFmt = function (cents) {
    var n = Math.round(Number(cents || 0) / 100);
    return 'Rs. ' + n.toLocaleString('en-PK', { maximumFractionDigits: 0 });
  };

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function updateBadge(cart) {
    var badge = document.querySelector('[data-s47-cart-count]');
    var btn = document.querySelector('[data-s47-cart-toggle]');
    if (!badge || !btn) return;
    var n = cart.item_count || 0;
    badge.textContent = String(n);
    btn.classList.toggle('has-items', n > 0);
  }

  /* ---------------- Drawer open/close ---------------- */
  function openDrawer() {
    var d = document.getElementById('s47-cart-drawer');
    if (!d) return;
    d.hidden = false;
    d.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var panel = d.querySelector('.s47-drawer__panel');
    if (panel) panel.focus();
  }

  function closeDrawer() {
    var d = document.getElementById('s47-cart-drawer');
    if (!d) return;
    d.hidden = true;
    d.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ---------------- Re-render drawer body from /cart.js ---------------- */
  function renderDrawer(cart) {
    var d = document.getElementById('s47-cart-drawer');
    if (!d) return;
    var body = d.querySelector('[data-s47-drawer-body]');
    var foot = d.querySelector('[data-s47-drawer-foot]');
    var subtotal = d.querySelector('[data-s47-drawer-subtotal]');

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML =
        '<div class="s47-drawer__empty">' +
          '<p>Your cart is empty.</p>' +
          '<a class="s47-btn s47-btn--ghost" href="/collections/all" data-s47-drawer-close>Browse the shop</a>' +
        '</div>';
      if (foot) foot.hidden = true;
      return;
    }

    var html = '<ul class="s47-cart__lines" role="list" data-s47-drawer-lines>';
    cart.items.forEach(function (li) {
      var img = li.image ? '<img src="' + li.image + '" alt="" width="100" height="100" loading="lazy">' : '';
      var variantTitle = (li.variant_title && li.variant_title !== 'Default Title')
        ? '<div class="s47-cli__variant">' + li.variant_title + '</div>' : '';
      html +=
        '<li class="s47-cli s47-cli--drawer" data-s47-line-key="' + li.key + '" data-s47-line-id="' + li.variant_id + '">' +
          '<div class="s47-cli__media"><a href="' + li.url + '">' + img + '</a></div>' +
          '<div class="s47-cli__body">' +
            '<a class="s47-cli__title" href="' + li.url + '">' + (li.product_title || li.title) + '</a>' +
            variantTitle +
            '<div class="s47-cli__row">' +
              '<div class="s47-cli__qty">' +
                '<button type="button" class="s47-cli__qty-btn" data-s47-line-step="-1" aria-label="Decrease">−</button>' +
                '<input type="number" value="' + li.quantity + '" min="0" inputmode="numeric" pattern="[0-9]*" class="s47-cli__qty-input" data-s47-line-qty>' +
                '<button type="button" class="s47-cli__qty-btn" data-s47-line-step="1" aria-label="Increase">+</button>' +
              '</div>' +
              '<div class="s47-cli__price" data-s47-line-price>' + moneyFmt(li.final_line_price) + '</div>' +
            '</div>' +
            '<button type="button" class="s47-cli__remove" data-s47-line-remove>Remove</button>' +
          '</div>' +
        '</li>';
    });
    html += '</ul>';
    body.innerHTML = html;
    if (foot) foot.hidden = false;
    if (subtotal) subtotal.textContent = moneyFmt(cart.total_price);
  }

  function refreshAll() {
    return getCart().then(function (cart) {
      updateBadge(cart);
      renderDrawer(cart);
      // Also update cart-page subtotal if we're on /cart
      var pageSubtotal = document.querySelector('[data-s47-cart-subtotal]');
      if (pageSubtotal) pageSubtotal.textContent = moneyFmt(cart.total_price);
      return cart;
    });
  }

  /* ---------------- PDP add-to-cart interception ---------------- */
  function onPdpSubmit(form, e) {
    e.preventDefault();
    var fd = new FormData(form);
    var atc = form.querySelector('[data-s47-pdp-atc]');
    if (atc) { atc.disabled = true; atc.classList.add('is-loading'); }

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' },
      body: fd
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(refreshAll)
      .then(openDrawer)
      .catch(function (err) {
        var msg = (err && (err.description || err.message)) || 'Could not add to cart.';
        if (window.S47 && window.S47.toast) window.S47.toast(msg);
        else alert(msg);
      })
      .finally(function () {
        if (atc) { atc.disabled = false; atc.classList.remove('is-loading'); }
      });
  }

  /* ---------------- Cart line qty / remove (page + drawer) ---------------- */
  var pendingTimer = null;
  function changeLine(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function onLineAction(li, action, value) {
    var key = li.getAttribute('data-s47-line-key');
    if (!key) return;
    var input = li.querySelector('[data-s47-line-qty]');
    var current = Number(input ? input.value : 1) || 1;
    var next = current;
    if (action === 'step') next = Math.max(0, current + Number(value));
    else if (action === 'set') next = Math.max(0, Number(value));
    else if (action === 'remove') next = 0;

    if (input) input.value = String(next);
    if (next === 0) li.classList.add('is-removing');

    changeLine(key, next).then(refreshAll);
  }

  /* ---------------- Wire it up ---------------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action$="/cart/add"]');
    if (form) onPdpSubmit(form, e);
  });

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-s47-cart-toggle]');
    if (toggle) { e.preventDefault(); openDrawer(); return; }

    var close = e.target.closest('[data-s47-drawer-close]');
    if (close) { e.preventDefault(); closeDrawer(); return; }

    var step = e.target.closest('[data-s47-line-step]');
    if (step) {
      var li = step.closest('[data-s47-line-key]');
      if (li) onLineAction(li, 'step', step.getAttribute('data-s47-line-step'));
      return;
    }

    var rm = e.target.closest('[data-s47-line-remove]');
    if (rm) {
      var li2 = rm.closest('[data-s47-line-key]');
      if (li2) onLineAction(li2, 'remove');
      return;
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-s47-line-qty]');
    if (!input) return;
    var li = input.closest('[data-s47-line-key]');
    if (li) {
      clearTimeout(pendingTimer);
      pendingTimer = setTimeout(function () {
        onLineAction(li, 'set', input.value);
      }, 200);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  /* ---------------- Initial badge sync on every page ---------------- */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshAll);
  } else {
    refreshAll();
  }
})();
